<form (ngSubmit)="save()" [formGroup]="form">
  <div fxLayout="row" fxLayoutAlign="start center" mat-dialog-title>
    <h2 *ngIf="isCreateMode()" class="headline m-0" fxFlex="auto">
      {{ 'CREATE_JOB_CUSTOM_FIELD' | translate }}
    </h2>
    <h2 *ngIf="isUpdateMode()" class="headline m-0" fxFlex="auto">
      {{ 'UPDATE_JOB_CUSTOM_FIELD' | translate }}
    </h2>
    <button class="text-secondary" mat-dialog-close mat-icon-button type="button">
      <mat-icon [icIcon]="icClose"></mat-icon>
    </button>
  </div>

  <mat-divider class="-mx-6 text-border"></mat-divider>

  <mat-dialog-content fxLayout="column">
    <mat-form-field class="flex-auto mt-4" appearance="outline">
      <mat-label>{{ 'JOB_CUSTOM_FIELD_NAME' | translate }}</mat-label>
      <input
        cdkFocusInitial
        formControlName="customFieldName"
        matInput
        placeholder="{{ 'ENTER_JOB_CUSTOM_FIELD_NAME' | translate }}" />
      <mat-icon class="mr-3" matPrefix>short_text </mat-icon>
    </mat-form-field>

    <mat-form-field class="flex-auto" appearance="outline">
      <mat-label>{{ 'ABBR' | translate }}</mat-label>
      <input
        formControlName="customFieldAbbreviation"
        matInput
        placeholder="{{ 'ENTER_ABBR_NAME' | translate }}" />
      <mat-icon class="mr-3" matPrefix>short_text </mat-icon>
    </mat-form-field>
    <mat-form-field class="flex-auto m" appearance="outline">
      <mat-label>{{ 'ORDER' | translate }}</mat-label>
      <mat-select
        formControlName="customFieldOrder"
        disableOptionCentering
        panelClass="mat-select-custom-panel">
        <mat-option value="0">0</mat-option>
        <mat-option value="1">1</mat-option>
        <mat-option value="2">2</mat-option>
        <mat-option value="3">3</mat-option>
        <mat-option value="4">4</mat-option>
        <mat-option value="5">5</mat-option>
        <mat-option value="6">6</mat-option>
        <mat-option value="7">7</mat-option>
        <mat-option value="8">8</mat-option>
        <mat-option value="10">10</mat-option>
        <mat-option value="11">11</mat-option>
        <mat-option value="12">12</mat-option>
      </mat-select>
      <mat-icon class="mr-3" matPrefix>reorder</mat-icon>
    </mat-form-field>
    <mat-form-field class="flex-auto m" appearance="outline">
      <mat-label>{{ 'LOCATION' | translate }}</mat-label>
      <mat-select
        formControlName="customFieldLocation"
        disableOptionCentering
        panelClass="mat-select-custom-panel">
        <mat-option value="0">{{ 'PUBLIC' | translate }}</mat-option>
        <mat-option value="1">{{ 'INTRANET' | translate }}</mat-option>
        <mat-option value="2">{{ 'INTERNAL' | translate }}</mat-option>
      </mat-select>
      <mat-icon class="mr-3" matPrefix [icIcon]="icMyLocation"></mat-icon>
    </mat-form-field>
    <mat-form-field class="flex-auto m" appearance="outline">
      <mat-label>{{ 'TYPE' | translate }}</mat-label>
      <mat-select
        formControlName="customFieldType"
        disableOptionCentering
        panelClass="mat-select-custom-panel">
        <mat-option value="0">{{ 'TEXTBOX' | translate }}</mat-option>
        <mat-option value="1">{{ 'DROPDOWN' | translate }}</mat-option>
        <mat-option value="2">{{ 'CHECKBOX' | translate }}</mat-option>
        <mat-option value="3">{{ 'RADIO' | translate }}</mat-option>
      </mat-select>
      <mat-icon class="mr-3" matPrefix>subject</mat-icon>
    </mat-form-field>
    <!-- <mat-form-field class="flex-auto m" appearance="outline">
        <mat-label>Selection Value</mat-label>
        <input formControlName="selectFromValue" matInput placeholder="Enter Selection value" />
        <mat-icon class="mr-3" matPrefix [icIcon]="icSelectAll"> </mat-icon>
      </mat-form-field> -->

    <div
      class="flex-auto w-full custom-select"
      fxLayout="column"
      fxLayoutAlign="start start">
      <div class="flex-auto w-full" fxLayout="row" fxLayoutAlign="start center">
        <mat-form-field class="example-chip-list w-full" appearance="outline">
          <mat-label>{{ 'SELECTION_VALUE' | translate }}</mat-label>
          <mat-chip-list #chipList3 aria-label="Fruit selection">
            <mat-chip
              *ngFor="let fruit of fruits3"
              [selectable]="selectable3"
              [removable]="removable3"
              (removed)="remove3(fruit)">
              {{ fruit }}
              <mat-icon matChipRemove *ngIf="removable3">cancel</mat-icon>
            </mat-chip>
            <!-- <mat-icon class="mr-3" matPrefix [icIcon]="icSelectAll"> </mat-icon> -->
            <input
              placeholder="{{ 'TYPE_HERE' | translate }}"
              #fruitInput3
              formControlName="selectFromValue"
              [matAutocomplete]="auto3"
              [matChipInputFor]="chipList3"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes3"
              (matChipInputTokenEnd)="add3($event)" />
          </mat-chip-list>
          <mat-icon class="mr-3" matPrefix [icIcon]="icSelectAll"> </mat-icon>
          <mat-autocomplete #auto3="matAutocomplete" (optionSelected)="selected3($event)">
            <mat-option *ngFor="let fruit of filteredFruits3 | async" [value]="fruit">
              {{ fruit }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
    </div>

    <!-- <mat-form-field class="flex-auto m" appearance="outline">
        <mat-label>Selection Value</mat-label>
        <input formControlName="selectFromValue" matInput placeholder="Enter Selection value" />
        <mat-icon class="mr-3" matPrefix [icIcon]="icSelectAll"> </mat-icon>
      </mat-form-field> -->

    <mat-form-field class="flex-auto m" appearance="outline">
      <mat-label>{{ 'DISPLAY' | translate }}</mat-label>
      <mat-select
        formControlName="customFieldDisplayFor"
        disableOptionCentering
        panelClass="mat-select-custom-panel">
        <mat-option value="0">{{ 'ALL' | translate }}</mat-option>
        <mat-option value="1">{{ 'HM' | translate }}</mat-option>
        <mat-option value="2">{{ 'All_BUT_HM' | translate }}</mat-option>
      </mat-select>
      <mat-icon class="mr-3" matPrefix>insert_chart_outlined</mat-icon>
    </mat-form-field>

    <div
      class="flex-auto m"
      fxLayout="row"
      fxLayout.xs="row"
      fxLayout.md="row"
      fxLayout.sm="column">
      <mat-label class="mr-3">{{ 'REQUIRED' | translate }}</mat-label>
      <mat-slide-toggle
        color="primary"
        [checked]="required"
        (change)="changeRequired($event)"></mat-slide-toggle>
    </div>

    <div
      class="mt-4"
      fxLayout="row"
      fxLayout.xs="row"
      fxLayout.md="row"
      fxLayout.sm="column">
      <mat-label class="mr-6">{{ 'ACTIVE' | translate }}</mat-label>
      <mat-slide-toggle
        color="primary"
        [checked]="status"
        (change)="changeStatus($event)"></mat-slide-toggle>
    </div>
  </mat-dialog-content>
  <mat-divider></mat-divider>
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close type="button" class="btn-close">CANCEL</button>
    <button *ngIf="isCreateMode()" class="btn-action" mat-button type="submit">
      {{ 'CREATE_JOBFIELD' | translate }}
    </button>
    <button *ngIf="isUpdateMode()" class="btn-action" mat-button type="submit">
      {{ 'UPDATE_JOBFIELD' | translate }}
    </button>
  </mat-dialog-actions>
</form>

<mat-menu #settingsMenu="matMenu" xPosition="before" yPosition="below">
  <button mat-menu-item>
    <mat-icon [icIcon]="icPrint"></mat-icon>
    <span>{{ 'PRINT' | translate }}</span>
  </button>

  <button mat-menu-item>
    <mat-icon [icIcon]="icDownload"></mat-icon>
    <span>{{ 'EXPORT' | translate }}</span>
  </button>

  <button mat-menu-item>
    <mat-icon [icIcon]="icDelete"></mat-icon>
    <span>{{ 'DELETE' | translate }}</span>
  </button>
</mat-menu>
